import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-search-skeleton-row',
  template: `
    <div class="skeleton-row" aria-hidden="true">
      <div class="skeleton-row__thumb"></div>
      <div class="skeleton-row__lines">
        <div class="skeleton-row__line skeleton-row__line--title"></div>
        <div class="skeleton-row__line skeleton-row__line--meta"></div>
      </div>
      <div class="skeleton-row__price"></div>
    </div>
  `,
  styleUrl: './search-skeleton-row.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchSkeletonRowComponent {}
